// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment_overview_header_container_tab_content_container_cards_container {
    margin-top: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 16px;
}

.payment_overview_header_container_tab_content_container_card {
    background-color: #ffffff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);
    min-height: 120px;
}

.payment_overview_header_container_tab_content_container_card_grid {
    display: flex;
    justify-content: space-between;
}

.payment_overview_header_container_tab_content_container_card_icon_container {
    width: 60px;
    height: 60px;
    border-radius: 20px;
    background-color: #F6F6FA;
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment_overview_header_container_tab_content_container_card_content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.payment_overview_header_container_tab_content_container_card_content > h6 {
    font-size: 16px;
    font-weight: bolder;
    color: #767493;
    margin-bottom: 18px;
}

.payment_overview_header_container_tab_content_container_card_content > h5 {
    font-size: 30px;
    font-weight: bold;
    color: #0E0A40;
}

@media (max-width: 1300px) {
    .payment_overview_header_container_tab_content_container_cards_container {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
}

@media (max-width: 1187px) {
    .payment_overview_header_container_tab_content_container_cards_container {
        grid-template-columns: 1fr 1fr 1fr;
    }
}

@media (max-width: 860px) {
    .payment_overview_header_container_tab_content_container_cards_container {
        grid-template-columns: 1fr 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Payments/Overview/PaymentsOverviewHeaderContainer/Tabs/PaymentsOverviewHeaderContainerCardInfoTab/PaymentsOverviewHeaderContainerCardInfoTab.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAGlB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".payment_overview_header_container_tab_content_container_cards_container {\n    margin-top: 32px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-gap: 16px;\n}\n\n.payment_overview_header_container_tab_content_container_card {\n    background-color: #ffffff;\n    padding: 16px;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    -moz-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    min-height: 120px;\n}\n\n.payment_overview_header_container_tab_content_container_card_grid {\n    display: flex;\n    justify-content: space-between;\n}\n\n.payment_overview_header_container_tab_content_container_card_icon_container {\n    width: 60px;\n    height: 60px;\n    border-radius: 20px;\n    background-color: #F6F6FA;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.payment_overview_header_container_tab_content_container_card_content {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.payment_overview_header_container_tab_content_container_card_content > h6 {\n    font-size: 16px;\n    font-weight: bolder;\n    color: #767493;\n    margin-bottom: 18px;\n}\n\n.payment_overview_header_container_tab_content_container_card_content > h5 {\n    font-size: 30px;\n    font-weight: bold;\n    color: #0E0A40;\n}\n\n@media (max-width: 1300px) {\n    .payment_overview_header_container_tab_content_container_cards_container {\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n    }\n}\n\n@media (max-width: 1187px) {\n    .payment_overview_header_container_tab_content_container_cards_container {\n        grid-template-columns: 1fr 1fr 1fr;\n    }\n}\n\n@media (max-width: 860px) {\n    .payment_overview_header_container_tab_content_container_cards_container {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
